(() => {
    class Item {

        id;

        repeater;

        model;

        fields;

        updated;

        title;

        conditionals;

        sync;

        constructor(repeater, id, model, updated) {
            this.repeater = repeater;
            this.id = id;
            this.model = model;
            this.fields = {};
            this.updated = updated;
            this.conditionals = {};
            this.sync = {};
            this.title = null;
        }

        render(strings, callback = null) {
            const collapsed = this.model.getMetadata('collapsed', false);
            const controls = {
                handle: `<i class="drag-handle" title="${strings.move}">${window.Repeater.icon('bars')}</i>`,
                toggle: `<a href="#" data-action="toggle" title="${strings.toggle}">${window.Repeater.icon('open')}${window.Repeater.icon('close')}</a>`
            }
            const actions = {
                copy: `<a href="#" data-action="copy" title="${strings.copy}">${window.Repeater.icon('copy')}</a>`,
                paste: `<a href="#" data-action="paste" title="${strings.paste}">${window.Repeater.icon('paste')}</a>`,
                moveUp: `<a href="#" data-action="moveUp" title="${strings.moveUp}">${window.Repeater.icon('up')}</a>`,
                moveDown: `<a href="#" data-action="moveDown" title="${strings.moveDown}">${window.Repeater.icon('down')}</a>`,
                prepend: `<a href="#" data-action="prepend" title="${strings.add}">${window.Repeater.icon('add')}</a>`,
                delete: `<a href="#" data-action="delete" title="${strings.delete}">${window.Repeater.icon('delete')}</a>`
            };
            if (typeof callback === 'function') {
                callback(this, controls, actions);
            }
            return `<div id="${this.id}" class="repeater-item ${collapsed ? 'is-collapsed' : ''}">
                <div class="item-header">
                    <div class="header-title">
                        ${Object.values(controls).join("\r\n")}
                        <span data-title="${strings.item}"></span>
                    </div>
                    <div class="header-actions">${Object.values(actions).join("\r\n")}</div>
                </div>
                <div class="item-fields"></div>
            </div>`;
        }

        addField(container, field, initial = '', asCollapsed = false) {
            const id = window.Repeater.randomString(16);
            const markup = field.render(id);
            const label = field.options.label ? field.label(id) : null;
            const hidden = field.options.hidden || false;
            const wrapper = document.createElement('div');
            wrapper.id = id;
            wrapper.className = `field`;
            if (hidden) {
                wrapper.classList.add('is-hidden');
            }
            if (label !== null) {
                wrapper.insertAdjacentHTML('beforeend', label);
            }
            wrapper.insertAdjacentHTML('beforeend', markup);
            container.append(wrapper);
            this.model.addField(field.options.name, initial);
            if (asCollapsed) {
                 this.title = document.getElementById(this.id).querySelector('.header-title span');
            }
            if ( typeof field.options.conditional !== 'undefined' ) {
                if ( field.options.conditional.type === 'callback' ) {
                    this.conditionals['_global'] = this.conditionals['_global'] || []
                    this.conditionals['_global'].push({
                        include: Array.isArray(field.options.conditional.field) ? field.options.conditional.field : [field.options.conditional.field],
                        callback: field.options.conditional.value,
                        field: field
                    });
                } else {
                    this.conditionals[field.options.conditional.field] = this.conditionals[field.options.conditional.field] || [];
                    if (! ['empty', 'notEmpty', 'equal', 'notEqual', 'matches', 'notMatches', 'contains'].includes(field.options.conditional.type) ) {
                        throw new Error(`Conditional of type "${field.options.conditional.type}" is not supported`);
                    }
                    this.conditionals[field.options.conditional.field].push({
                        type: field.options.conditional.type,
                        value: field.options.conditional.value,
                        field: field,
                    });
                }
            }
            if ( typeof field.options.sync !== 'undefined' ) {
                if (typeof field.options.sync.field !== 'undefined' ) {
                    this.sync[field.options.sync.field] = this.sync[field.options.sync.field] || [];
                    this.sync[field.options.sync.field].push({
                        field: field,
                        callback: field.options.sync.callback
                    });
                } else {
                    this.repeater.container.addEventListener('repeater.changed', () => {
                        field.options.sync.callback(field, this.repeater, null);
                    });
                }
            }
            field.init(wrapper, (value) => {
                if (asCollapsed) {
                    if (typeof field.options.collapsed === 'function') {
                        this.updateTitle(field.options.collapsed(value, field));
                    } else {
                        this.updateTitle(value);
                    }
                }
                this.model.updateField(field.options.name, value);
                this.updated(field);
                this.applyConditionals(field, value);
                this.syncFields(field, value);
            });
            field.refresh();
            if (asCollapsed) {
                if (typeof field.options.collapsed === 'function') {
                    this.updateTitle(field.options.collapsed(initial, field));
                } else {
                    this.updateTitle(initial);
                }
            }
            this.fields[field.options.name] = field;
        }

        applyConditionals(field, value) {
            const conditionals = this.conditionals[field.options.name] || [];
            conditionals.forEach((conditional) => {
                let result = false;
                switch (conditional.type) {
                    case 'empty':
                        result = value === '' || value === 0 || value === false;
                    break;
                    case 'notEmpty':
                        result = value !== '' && value !== 0 && value !== false;
                    break;
                    case 'equal':
                        result = value === conditional.value;
                    break;
                    case 'notEqual':
                        result = value !== conditional.value;
                    break;
                    case 'matches':
                    case 'notMatches':
                        const expr = new RegExp(conditional.value, 'i');
                        const test = expr.test(value);
                        result = conditional.type === 'matches' ? test : !test;
                    break;
                    case 'contains':
                        result = value.indexOf(value) >= 0;
                    break;
                    case 'notContains':
                        result = value.indexOf(value) === -1;
                    break;
                }
                conditional.field.conditional(result);
            });
            const globals = this.conditionals['_global'] ?? [];
            globals.forEach(conditional => {
                if ( conditional.include.includes(field.options.name) ) {
                    let result = null;
                    if ( conditional.include.length === 1 ) {
                        // Simple case, just one field
                        result = conditional.callback(value);
                    } else {
                        // Multiple fields, collect values and run callback
                        const values = {};
                        conditional.include.forEach(field => values[field] = this.model.getField(field));
                        result = conditional.callback(values);
                    }
                    if ( typeof result !== 'undefined' ) {
                        conditional.field.conditional(result);
                    }
                }
            });
        }

        syncFields(field, value) {
            const items = this.sync[field.options.name] || [];
            items.forEach((item) => {
                item.callback(item.field, field, value);
            });
        }

        created() {
            Object.entries(this.fields).forEach(([name, field]) => {
                const value = this.model.getField(name);
                this.applyConditionals(field, value);
                this.syncFields(field, value);
            });
        }

        updateTitle(value) {
            this.title.textContent = value || (this.repeater.schema.item || this.title.dataset.title);
        }

        serialize() {
            return this.model.serialize();
        }

        unserialize(data) {
            this.model.unserialize(data);
            Object.values(this.fields).forEach((field) => {
                field.refresh();
            });
            this.created();
        }
    }

    window.Repeater = window.Repeater || {};
    window.Repeater.Item = Item;
})();
